export default __webpack_public_path__ + "static/media/slack-square.e659b526.svg";